export const STAGES_SHORT_LABELS = ['Idea', 'R&D', 'Evaluation', 'Financing', 'Implementation', 'Operation'];
export const STAGES_SHORT_LABELS_DEU = ['Idee', 'F&E', 'Evaluierung', 'Finanzierung', 'Implementierung', 'Betrieb'];
export const STAGES_SHORT_LABELS_UA = ['Ідея', 'R&D', 'Вибір стратегії', 'Фінансування', 'Впровадження', 'Операційна діяльність'];
